import Lang from 'lang.js';
import messages from '@lang/json/client-portal.json';

window.Lang = new Lang({
    messages: messages,
    locale: window.nal.locale,
    fallback: 'en',
});